__webpack_require__.p = "/memory-game-reactjs/";